import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { throttle } from '../utils/lodashUtils';
import rootReducer from '../reducers';
import { loadState, saveState } from './browserStorage';

/* eslint-disable no-underscore-dangle */
const composeEnhancers =
  process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;
/* eslint-enable no-underscore-dangle */

const enhancer = composeEnhancers(applyMiddleware(thunk));

export default function appStore(initialState) {
  const savedAuth = loadState('auth');
  const stateToUse = initialState || {
    auth: savedAuth,
  };
  const store = createStore(rootReducer, stateToUse, enhancer);

  store.subscribe(
    throttle(() => {
      const updatedAuth = Object.assign({}, store.getState().auth);
      saveState({
        auth: updatedAuth,
      });
    }),
    1000,
  );

  return store;
}
